import { Box } from '@mui/material';
import { CreditReportGridData } from './CreditReportGridData';
import { ILoan } from './interfaces/interfaces';

export const StudentLoan = ({ loan }: ILoan) => (
  <Box marginBottom={2}>
    <CreditReportGridData tableName="Student Loan" data={loan} />
  </Box>
);
